import { Locker, Module, PickupBox, Reservation } from './types';

export const cleanLocalStorage = (): void => {
  localStorage.removeItem('pharmacies');
};

export const reformatPickupBox = (initialPickupBox: PickupBox): PickupBox => {
  initialPickupBox.info.modules.forEach((module: Module) => {
    module.lockers.forEach((locker: Locker) => {
      locker.status = 'free';
    });
  });

  const modules: Module[] = initialPickupBox.info.modules.map(
    (module: Module, index: number) => ({
      ...module,
      id: module.id ?? index
    })
  );

  if (initialPickupBox) {
    Object.keys(modules).forEach((moduleIndex) => {
      const lockers: Locker[] = modules[+moduleIndex].lockers;

      Object.keys(lockers).forEach((lockerIndex) => {
        const lockerId: Locker = lockers[+lockerIndex];

        if (
          (!lockerId.inactive && lockerId.status === 'reserved') ||
          lockerId.status === 'expired'
        ) {
          lockerId.status;
        } else if (lockerId.inactive) {
          lockerId.status = 'inactive';
        }
      });
    });
  }

  if (initialPickupBox.reservations) {
    const reservations: readonly Reservation[] = initialPickupBox.reservations;

    Object.keys(initialPickupBox.reservations).forEach((reservationId) => {
      // eslint-disable-next-line
      const reservationLockerId: any = reservations[+reservationId];
      const lockersWithReservation: string[] =
        reservationLockerId.lockerId || '';

      if (lockersWithReservation) {
        const lockers = lockersWithReservation.filter(
          (id: string) => id.length !== 0
        );
        lockers.forEach((lockerId: string) => {
          const moduleId = parseInt(lockerId.split('-')[0]);
          const lockerIndex = parseInt(lockerId.split('-')[1]);

          let status = 'free';
          const currentTime = Math.round(new Date().getTime() / 1000);
          if (reservationLockerId) {
            reservationLockerId.reservedTime > currentTime
              ? (status = 'reserved')
              : (status = 'expired');
          }

          const foundModuleIndex: number = modules.findIndex(
            (mod: Module) => mod.id === moduleId
          );

          if (foundModuleIndex !== -1) {
            modules[foundModuleIndex].lockers[lockerIndex] = {
              ...modules[foundModuleIndex].lockers[lockerIndex],
              status,
              order: reservationLockerId
            };
          }
        });
      }
    });
  }

  return initialPickupBox;
};
